"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notImplemented = void 0;
const not_implemented_exception_1 = require("../exceptions/not-implemented-exception");
/**
 * Helper function for throwing a {@link NotImplementedException}.
 *
 * @param message The message supplied to {@link NotImplementedException}
 */
function notImplemented(message) {
    return () => {
        throw new not_implemented_exception_1.NotImplementedException(message);
    };
}
exports.notImplemented = notImplemented;
//# sourceMappingURL=not-implemented.js.map